import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { UUID } from 'angular2-uuid';
import { isDefined } from 'ionic-angular/util/util';
import { Observable } from 'rxjs/Observable';
import { INormalisedResult } from '../../core/interfaces/interfaces';
import { VASRestService } from '../../core/services/api/vas-rest';
import { DtoHelper } from '../../core/store/dto/dto-helper';
import { Job } from '../../vas/business-objects/job/job.model';
import { Report } from '../../vas/business-objects/report/report.model';
import { VasAppFacade } from '../../vas/services/vas-app-facade.service';
import { zip } from 'rxjs/observable/zip';

@Injectable()
export class ReportService {

    constructor(
        protected appFacade: VasAppFacade,
        protected apiService: VASRestService
    ) {
    }

    /**
     * Returns a list of Report for the specified job id
     * @param accountId {string}
     * @param jobId {string}
     * @todo ideally we would pass the job id to the api and let it filter
     */
    getJobReports(
        accountId: string,
        jobId: string
    ): Observable<Array<Report>> {
        return this.appFacade.objects.report.api.getByJob(accountId, jobId)
            .catch((response: Response) => {

                if (response.status !== 404) {
                    return Observable.throw(response);
                }

                return Observable.of([]);
            });
    }

    syncReportsByJob(job: Job): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getJobReports(job.account, job.id).subscribe(
                (reports: Array<Report>) => {
                    reports.forEach(report => {
                        this.appFacade.objects.report.store.insert(report);
                    });
                    resolve();
                },
                reject
            );
        });
    }

    /**
     * Request the server to generate a report for the given job and report
     * layout
     * @param accountId {string}
     * @param jobId {string}
     * @param reportLayoutId {string}
     * @param sendEmail {boolean}
     * @todo move this to the ReportApiFacade
     */
    requestReport(
        accountId: string,
        jobId: string,
        reportLayoutId: string,
        sendEmail: boolean = false
    ): Observable<Report> {

        const report = new Report({
            id: UUID.UUID(),
            account: accountId,
            job: jobId,
            reportLayout: reportLayoutId
        });

        const reportDto = DtoHelper.getDtoFromEntity('report', report);

        const requestBody = reportDto.getRequestBody();

        if (isDefined(requestBody.title)) {
            console.warn('the title property exists on the report request object');
            delete requestBody.title;
        }

        return this.appFacade.api
            // @todo this should use the ReportApiFacade create method
            .postAccountObject('report', report.account, requestBody)
            .concatMap(() => this.getReportFromServer(report));
    }

    getReportFromServer(report: Report): Promise<any> {
        return new Promise((resolve, reject) => {
            this.appFacade.api.simpleGet(`/accounts/${report.account}/reports/${report.id}`)
                .map(response => response.json())
                .toPromise()
                .then(resolve, reject);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/report.service.ts